module.exports = __webpack_public_path__ + "img/icon_card02.cd4e242b.png";